import { AxiosInstance } from "axios";
import { action, makeAutoObservable } from "mobx";
import http from "../../http/http";
import { ServiceResult } from "../../types/general-types";
import {
  GetEmergencyQuestionOptionDto,
  PublishQuestionCreateAnswerDto,
} from "./types";

class Store {
  static readonly id: string = "EmergencyPublishQuestionAnswerStore";

  edit!: GetEmergencyQuestionOptionDto[] | undefined;

  get api(): AxiosInstance {
    return http;
  }

  constructor() {
    makeAutoObservable(this);
  }
  @action.bound async getSafeStatus(key: string) {
    const data: any = {
      hashedKey: key,
    };
    const response: ServiceResult<GetEmergencyQuestionOptionDto> =
      await this.api
        .post("/emergency-publish-question/get-question", data)
        .then((res) => res.data);
    return response;
  }

  @action.bound async save(input: PublishQuestionCreateAnswerDto) {
    const response: ServiceResult = await this.api
      .post("/emergency-publish-question/save-answer", input, {
        skipSuccessToast: true,
      })
      .then((res) => res.data);
    return response;
  }
}
export default Store;
